export default (data: {
  email: string;
  name: string;
  type: 'webinar' | 'module',
}) => fetch('https://mail-server.growheads.ru/api/mail', {
  method: 'POST',
  body: JSON.stringify(data),
});
